module.exports = __webpack_public_path__ + "media/images/huddersfield-bd79a4f5fd9ce2e1cbf4709d1bc46e08.png";